/**
 * @title register-user.js: Sub-module for Register User (Create Account) page
 * @description This module is used to handle registering new user account.
 * @dependency password-strength.js
 */
define(['passwordStrength'], function(passwordStrength) {
  let RegisterUser = {

    /**
     * Initialization function.
     */
    init: function() {
      COSTCO.util.maskMembershipInput();
      if ($('#primary-membership-block').length != 0) {
        this.focusInput('validation-error', 'first_name');
      } else {
        this.focusInput('validation-error', 'register_email1');
      }
      this.activatePopovers('co-help');
      this.activatePopovers('tooltip-without-question-icon');
      this.validationRules();
      this.validateForm('RegisterForm');
      sessionStorage.removeItem("changeValidationFlag");
      passwordStrength.init();

      $('#buy-membership-button').unbind('click').bind('click', function() {
        if ($.cookie('cartCountCookie') > 0) {
          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
        } else {
          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
        }
      });

      console.log('Register User sub-module initialized.');
    },
    /**
     * Focuses the first input field of a given class. If there is no input element with given class,
     * focus on default input field with given id.
     * @param {string} inputClass - HTML class attribute of the input field to be focused.
     * @param {string} defaultInputId - HTML it attribute of the input field to be focused if class does not exist.
     * @return {void}
     */
    focusInput: function(inputClass, defaultInputId) {
      $(window).on('load',function() {
        if ($('input.' + inputClass).length > 0) {
          $('input.' + inputClass + ':first').focus();
        } else {
          $('input#' + defaultInputId).focus();
          //          window.scrollTo(0, 0);
        }
      });
    },
    /**
     * Activates popovers on Costco tooltips.
     * @param {string} tooltipClass - Tooltip class.
     * @return {void}
     */
    activatePopovers: function(tooltipClass) {
      $('.' + tooltipClass).popover();
    },
    /**
     * Validation rules for the inputs associated with creating an account.
     * @return {void}
     */
    validationRules: function() {
      $.validator.addMethod('email', function(value, element) {
        return /^.+@(([^.])+\.)+([^.])+$/i.test(value);
      }, messages.JS_VALID_EMAIL);

      $.validator.addMethod('passwordRule', function(value, element) {
        return /^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value);
      }, messages.JS_VALID_REQUIRED);

      $.validator.addMethod('costcoMembership', function(value, element) {
        return /^\d{12,16}$/.test(value);
      }, messages.ERR_INVALID_MEMBERSHIP_NO);
    },

    /**
     * Checks if cart is empty.
     * @return {void}
     *
     * isCartEmpty: function(){
    	let cartEmpty = true;
    	let cartCookie = $.cookie('cartCountCookie');
    	if(cartCookie != null && cartCookie != 'undefined'){
    		if(cartCookie > 0) {
    			cartEmpty = false;
    		}
    	}
    	return cartEmpty;
    },

     */

    /**
     * Validates the given form.
     * @param {string} formId - ID attribute of the form.
     * @return {void}
     */
    validateForm: function(formId) {
      $('#' + formId).validate({

        ignoreTitle: true,

        rules: {
          email1: {
            required: true,
            email: true,
            maxlength: 251
          },
          logonPassword: {
            required: true,
            passwordRule: true,
          },
          logonPasswordVerify: {
            required: true,
            passwordRule: true,
            equalTo: '#logonPassword',
          },
          userField2: {
            // required: true,
            costcoMembership: true,
          },
          lastNameOnMembership: {
            // required: true,
          },
        },

        messages: {
          email1: {
            required: messages.ERR_REQUIRED_LOGON,
            email: messages.ERR_INVALID_EMAIL,
            maxlength: messages.ERR_EMAIL_MAX_LENGTH
          },
          logonPassword: {
            required: messages.ERR_REQUIRED_REGISTER_PASSWORD,
            // Password messages already handled by PasswordStrength.jsp
            passwordRule: '', // messages.ERR_CREATE_ACCOUNT_PASSWORD_INVALID,
          },
          logonPasswordVerify: {
            required: messages.ERR_REQUIRED_CONFIRM_PASSWORD,
            // Password messages already handled by PasswordStrength.jsp
            passwordRule: '', // messages.ERR_CREATE_ACCOUNT_PASSWORD_INVALID,
            equalTo: '', // messages.ERR_REQUIRED_PASSWORD_MATCH,
          },
          userField2: {
            required: messages.JS_VALID_REQUIRED,
            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
          lastNameOnMembership: {
            required: messages.JS_VALID_REQUIRED,
          },
        },
      });
    },
  };

  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.RegisterUser = RegisterUser;

  return RegisterUser;
});



// WEBPACK FOOTER //
// ./js/account/register-user.js